import { useState } from "react";
import { useDispatch } from "react-redux";
import { callPutApiWithAuth } from "utils/api";
import { Button, ErrorNotification, Modal, Spin } from "..";

export default function PpPopupModal({ visible, onAgreed }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleAgree = () => {
    setIsLoading(true);

    const onSuccess = (res) => {
      setIsLoading(false);
      if (onAgreed) onAgreed();
      dispatch({ type: "auth.RELOAD" });
    };

    const onFailed = (err) => {
      console.error("Failed to agree PP:", err);
      setIsLoading(false);
      ErrorNotification("Unable to update agreement. Please try again.");
    };

    callPutApiWithAuth(
      "my_account/agree_pp",
      { is_agreed_pp: 1 }, // ✅ send agreed flag
      onSuccess,
      onFailed
    );
  };

  return (
    <Modal
      visible={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={500}
    >
      <div className="text-center p-4">
        <h2 className="text-xl font-semibold mb-3">Policies & Procedures</h2>
        <p className="text-gray-600 mb-6">
          To continue using your account, you must confirm that you have read
          and agree to the company’s{" "}
          <a
            href="https://nuevalife.com/policies-and-procedures"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#0abab5",
            }}
          >
            Policies and Procedures
          </a>
        </p>

        <div className="flex justify-center">
          <Button
            bgColor="#0abab5"
            color="#fff"
            onClick={handleAgree}
            disabled={isLoading}
          >
            {isLoading ? <Spin spinning /> : "I Agree"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
